import { ApiRequestBody } from 'interfaces/ApiRequestBody'
import AgencyService from 'services/agenciesService'
import { CustomEmailParagraph } from 'types/agencySettings'

interface UpdateListingAgreementSettingsRequest extends ApiRequestBody {
  privacyPolicyLink?: string
  customEmailParagraphs?: CustomEmailParagraph[]
  AgencyId?: string
}

const UpdateListingAgreementSettings = async (
  requestBody: UpdateListingAgreementSettingsRequest
): Promise<number | undefined> => {
  const { getAuthToken, AgencyId, ...requestProperties } = requestBody

  if (!AgencyId) return

  const token = await getAuthToken()
  const service = new AgencyService(token)

  

  const result = await service.agencyService.put(
    `UpdateListingAgreementSettings?AgencyId=${AgencyId}`,
    { ...requestProperties }
  )

  return result.status
}

export default UpdateListingAgreementSettings
